import { Icons } from 'core/constants/icons'
import LogCardMessage from './log-card-message'
import Button from '../buttons/button'
import { useTranslation } from 'react-i18next'

interface IProps {
  onRetry?: () => Promise<unknown>
  error?: any
}

const reload = () => {
  window.location.reload()
  return Promise.resolve()
}

const ErrorCardMessage = ({ error, onRetry = reload }: IProps) => {
  const { t } = useTranslation()
  if (error) {
    console.error(error)
  }

  return (
    <LogCardMessage iconName={Icons.Error} messageKey="error.global.message">
      <Button className="dkt-button-size-small dkt-button-info" onClick={() => void onRetry()}>
        {t('retry')}
      </Button>
    </LogCardMessage>
  )
}

export default ErrorCardMessage
